/* eslint-disable no-control-regex */
import axios from "axios";

export const required = (value) => {
  return value && value.length ? undefined : "Required";
};

export const booleonRadioQuestionTrue = (value) => {
  return value === "true" ? "Please contact Heritage Victoria" : undefined;
};

export const booleonRadioQuestionFalse = (value) => {
  return value === "false" ? "Please contact Heritage Victoria" : undefined;
};

export const number = (value) =>
  value && !/^[0-9]*$/i.test(value) ? "Must be a number" : undefined;

export const greaterThanZero = (value) =>
  value && Number(value) === 0 ? "Must be more than “$0”" : undefined;

export const numberLimit = (value) =>
  value && !/^\d( ?\d){10}$/i.test(value)
    ? "Invalid ABN, must be 11 digits"
    : undefined;

export const email = (value) =>
  value && !/^[A-Z0-9._'%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email address"
    : undefined;

export const alphaNumeric = (value) =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? "Only alphanumeric characters"
    : undefined;

export const phoneNumber = (value) =>
  value && !/^[+()0-9 -]*[0-9]$/.test(value)
    ? "Invalid phone number"
    : undefined;

export const dateFormat = (value) =>
  value &&
  !/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(value)
    ? "Date format must be dd/mm/yyyy"
    : undefined;

export const oneContactNumberRequired = (value, allValues, props, name) => {
  const section = name.split(".")[0];
  const splitArraySection = name.split("[")[0];
  const arrayPositionPattern = /\[([^\]]+)\]/;
  let arraySectionPosition = section.match(arrayPositionPattern);

  if (splitArraySection === "owners") {
    if (
      allValues.owners[arraySectionPosition[1]] &&
      (allValues.owners[arraySectionPosition[1]].telephone ||
        allValues.owners[arraySectionPosition[1]].mobile)
    ) {
      return undefined;
    } else {
      return "At least one phone number is required";
    }
  } else {
    if (
      section &&
      allValues[section] &&
      (allValues[section]["telephone"] || allValues[section]["mobile"])
    ) {
      return undefined;
    } else {
      return "At least one phone number is required";
    }
  }
};

// export const characterPrefix = (value, prefixCharacter) => {
//     const prefixCharacterRegex = new RegExp("^" + prefixCharacter + "+[0-9 ]*[0-9]", "i");
//     return value && !prefixCharacterRegex.test(value)
//       ? `Invalid entry, must start with '${prefixCharacter}'`
//       : undefined
//   }

export const characterPrefixH = (value) => {
  return value && !/^H(.*)/.test(value)
    ? `Invalid VHR number, must start with 'H'`
    : undefined;
};

export const characterPrefixHnumber = (value) => {
  return value && !/^H[0-9 ]*[0-9]/.test(value)
    ? `Invalid VHR number, must start with 'H' and digits thereafter`
    : undefined;
};

export const characterPrefixP = (value) => {
  return value && !/^P(.*)/.test(value)
    ? `Invalid Pre app number, must start with 'P'`
    : undefined;
};

export const characterPrefixPnumber = (value) => {
  return value && !/^P[0-9 ]*[0-9]/.test(value)
    ? `Invalid Pre app number, must start with 'P' and digits thereafter`
    : undefined;
};

export const asyncValidateExemptionForm = async (values) => {
  if (
    values.preApplicationDiscussion &&
    values.preApplicationDiscussion === "true"
  ) {
    let preApplicationInvalid = { preApplicationEventNumber: "Invalid number" };

    const params = `?vhrNumber=${values.vhrNumber}&eventNumber=${values.preApplicationEventNumber}`;
    const options = {
      url:
        (process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_HOST_URL
          : window.location.origin) +
        `/_webservices/heritage/permit-exemptions/preapplication-check${params}`,
    };

    return axios.get(options.url).then(function (response) {
      if (
        response.data.code ||
        response.data.findIndex(
          (r) =>
            r.applicationLodgementFlag === false &&
            r.vhrNumber === values.vhrNumber &&
            r.eventNumber === values.preApplicationEventNumber &&
            r.preApplicationDiscussionFlag === true
        )
      ) {
        throw preApplicationInvalid;
      }
    });
  }
};

export const asyncValidatePermitApplication = async (values) => {
  if (
    values.preApplicationDiscussion &&
    values.preApplicationDiscussion === "true"
  ) {
    let preApplicationInvalid = { preApplicationEventNumber: "Invalid number" };
    const params = `?vhrNumber=${values.vhrNumber}&eventNumber=${values.preApplicationEventNumber}`;

    const options = {
      url:
        (process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_HOST_URL
          : window.location.origin) +
        `/_webservices/heritage/permit/preapplication-check${params}`,
    };

    return axios.get(options.url).then(function (response) {
      if (
        response.data.code ||
        response.data.findIndex(
          (r) =>
            r.applicationLodgementFlag === false &&
            r.vhrNumber === values.vhrNumber &&
            r.eventNumber === values.preApplicationEventNumber &&
            r.preApplicationDiscussionFlag === true
        )
      ) {
        throw preApplicationInvalid;
      }
    });
  }
};

export const percentage = (value) => {
  // const percentagePattern = /\b(?<!\.)(?!0+(?:\.0+)?%)(?:\d|[1-9]\d|100)(?:(?<!100)\.\d+)?%/;
  const percentagePatternForFormatedValue = /^[0-9][0-9]{0,1}$|^[0-9][0-9]{0,1}\.|^100/;

  return value && !percentagePatternForFormatedValue.test(value)
    ? "The percentage must be between 0% - 100%"
    : undefined;
};

export const percentageTwoDecimals = (value) => {
  const percentagePatternForFormatedValue = /^[0-9][0-9]{0,1}(?:[.,]\d{1,2})?$|^100$/;

  return value && !percentagePatternForFormatedValue.test(value)
    ? "The percentage must be between 0% - 100% and 1 - 2 decimal places"
    : undefined;
};

/**
 * Identify if the file name is less than 120 characters. If not, mark the file object
 * with an error.
 *
 * @param {array} files
 *
 * @return {void}
 */
export const fileNameLengthLessThanOneHundredTwentyChars = (files) => {
  const maxStringLength = 120;

  // Loop through the files and mark the ones that fail validation
  if (files && files.length > 0) {
    files.forEach((file) => {
      if (file.originalFileName.length > maxStringLength) {
        file.error = "Attachment name must be no larger than 120 characters";
      }
    });
  }
};

/**
 * Identify if the file name is less than 120 characters and ASCII. If not, mark the file object
 * with an error.
 *
 * @param {array} files
 *
 * @return {void}
 */
export const validateFileName = (files) => {
  const maxStringLength = 120;
  // Loop through the files and mark the ones that fail validation
  if (files && files.length > 0) {
    files.forEach((file) => {
      // eslint-disable-next-line no-control-regex
      if (
        file.originalFileName.length > maxStringLength &&
        !/^[\x00-\x7F]*$/.test(file.originalFileName)
      ) {
        file.error =
          "Attachment name must be no larger than 120 characters and name must not contain special characters";
      } else if (
        file.originalFileName.length > maxStringLength &&
        /^[\x00-\x7F]*$/.test(file.originalFileName)
      ) {
        file.error = "Attachment name must be no larger than 120 characters";
      } else if (
        file.originalFileName.length < maxStringLength &&
        !/^[\x00-\x7F]*$/.test(file.originalFileName)
      ) {
        file.error = "Attachment name must not contain special characters";
      }
    });
  }
};
